module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-100.woff2?7370c3679472e9560965ff48a4399d0b";